<!--




  <div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">

      <div class="title mb-4">
        <h2>{{ current_module }} Reviews</h2>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 "> -->
<!-- <p>{{feedback|json}}</p> -->
<div class="Sub_admins_on">
  <div class="Sub_admins">
    <div class="media position-relative sub_image" *ngFor="let fdb of feedback">
      <div class="media-body">
        <h5 class="">
          <!-- Name:{{fdb.name}}<br /> -->
          <span>{{ fdb.created * 1000 | date : "longDate" }}</span>
        </h5>
        <p><b>To : </b>{{ fdb.feedbackName }}</p>
        <p><b>Message : </b>{{ fdb.description }}</p>
      </div>
      <div class="rating_userr">
        <span>
          <li class="lilist" *ngFor="let star of stars; let i = index">
            <i
              class="fa fa-star"
              *ngIf="fdb.star >= i + 0.5"
              [ngClass]="{
                'fa-star-half': fdb.star >= i + 0.5 && fdb.star < i + 1,
                'fa-star': fdb.star >= i + 1
              }"
              aria-hidden="true"
            >
            </i>
          </li>
        </span>
      </div>
    </div>
    <h4 *ngIf="review_length == 0">No reviews</h4>
  </div>
</div>
<!-- </div>
      </div>

    </div>

</div> -->
